import { FC } from 'react';
import orangedevLogo from 'assets/images/orangedev-logo.svg';
import darkOrangedevLogo from 'assets/images/orangedev-logo-dark.svg';
import { Box, SxProps, Typography, useTheme } from '@mui/material';

interface LogoProps {
    sx?: SxProps;
}

const PoweredBy: FC<LogoProps> = (props) => {
    const { sx } = props;
    const theme = useTheme();

    const logo = theme.palette.mode === 'dark' ? darkOrangedevLogo : orangedevLogo;

    return (
        <Box sx={{ position: 'absolute', bottom: 20, display: 'flex', flexDirection: 'column', alignItems: 'center', ...sx }}>
            <Typography variant="h6" sx={{ color: theme.palette.text.disabled }}>
                Powered by
            </Typography>
            <img src={logo} alt="Orangedev logo" width="100" />
        </Box>
    );
};
export default PoweredBy;
